import reduce from 'lodash/reduce';
import each from 'lodash/each';
import { NAMESPACE } from './namespace';

const PRINT_STYLE = 'printStyle';
const COMPOSITION = 'composition';

export default {
  [COMPOSITION]: state => state.composition,
  orderData: state => state.orderData,
  uniqueBackgroundRemovals: state => {
    let backgroundRemovalMap = {};
    each(state.composition.printPlates, printPlate => {
      each(printPlate.content, element => {
        if (element.type === 'upload' && element.bgRemoval === true) {
          backgroundRemovalMap[element.src] = 1;
        }
      });
    });
    return reduce(backgroundRemovalMap, (sum, n) => sum + n);
  },
  [PRINT_STYLE]: state => side => state.composition.printPlates[side].printStyle
};

export const GETTER_COMPOSITION_COMPOSITION = `${NAMESPACE}${COMPOSITION}`;
export const GETTER_COMPOSITION_PRINT_STYLE = `${NAMESPACE}${PRINT_STYLE}`;
